import React from "react";

const UserRemoveIcon16pxSvg = ({
    color = "#FF0066",
    width = 16,
    height = 16,
    ...props
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path d="M7.99994 9.3335C4.65994 9.3335 1.93994 11.5735 1.93994 14.3335C1.93994 14.5202 2.08661 14.6668 2.27327 14.6668H13.7266C13.9133 14.6668 14.0599 14.5202 14.0599 14.3335C14.0599 11.5735 11.3399 9.3335 7.99994 9.3335Z" fill={color} />
            <path d="M11.2336 3.86672C11.1536 3.54006 11.0202 3.22006 10.8336 2.92672C10.7069 2.71339 10.5402 2.50006 10.3602 2.31339C9.76022 1.71339 8.98022 1.38672 8.18022 1.34672C7.27356 1.28672 6.34689 1.62006 5.64689 2.31339C4.98689 2.96672 4.65356 3.84006 4.66689 4.72006C4.67356 5.55339 5.00689 6.38672 5.64022 7.02672C6.08022 7.46672 6.62022 7.76006 7.20022 7.89339C7.51356 7.97339 7.84689 8.01339 8.18022 7.98672C8.97356 7.95339 9.74689 7.64006 10.3536 7.02672C11.2136 6.16672 11.5069 4.96006 11.2336 3.86672ZM9.33355 6.00006C9.09355 6.24006 8.69356 6.24006 8.45356 6.00006L7.99355 5.54006L7.55355 5.98006C7.31356 6.22006 6.91356 6.22006 6.67356 5.98006C6.42689 5.73339 6.42689 5.34006 6.66689 5.10006L7.10689 4.66006L6.68022 4.24672C6.44022 4.00006 6.44022 3.60672 6.68022 3.35339C6.92689 3.11339 7.32022 3.11339 7.57355 3.35339L7.98689 3.78006L8.43355 3.33339C8.67355 3.09339 9.06689 3.09339 9.31356 3.33339C9.55356 3.57339 9.55356 3.97339 9.31356 4.21339L8.87356 4.65339L9.33355 5.12006C9.57355 5.36006 9.57355 5.76006 9.33355 6.00006Z" fill={color} />
        </svg>
    );
};

export default UserRemoveIcon16pxSvg;